import { Component, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import { ConfirmComponent } from "./confirm.component";


@Component({
  selector: 'parent-dialog',
  template: `<div class="modal-dialog" style="width: 800px;">
                <div class="modal-content" >
                   <div class="modal-header badge-primary">
                      <h4 class="modal-title">Parent dialog</h4>
                      <button type="button" class="close" (click)="close()" >&times;</button>
                   </div>
                   <div class="modal-body">
                     <p>bla-bla</p>
                     <p>bla-bla</p>
                     <p>bla-bla</p>
                   </div>
                   <div class="modal-footer">
                     <button type="button" class="btn btn-primary" (click)="confirm()" #setfocus>Close</button>
                   </div>
                </div>
             </div>`
})
export class ParentDialogComponent extends DialogComponent<null, null>  {

  constructor(dialogService: DialogService) {
    super(dialogService);
  }

  confirm() {
    var iConfirm =  {title: 'Confirm', message: 'Are you sure you want close dialog?'};
    this.dialogService.addDialog(ConfirmComponent,iConfirm).subscribe((isConfirmed)=>{
      if(isConfirmed) {
        this.close();
      }
    });
  }

  @ViewChild('setfocus', { static: true }) private elementref: ElementRef
  public ngAfterViewInit(): void {
    this.elementref.nativeElement.focus();
  }
}
